export default Object.freeze({
  Telesec: '0.2.262.1.10',
  extension: '0.2.262.1.10.0',
  mechanism: '0.2.262.1.10.1',
  authentication: '0.2.262.1.10.1.0',
  passwordAuthentication: '0.2.262.1.10.1.0.1',
  protectedPasswordAuthentication: '0.2.262.1.10.1.0.2',
  oneWayX509Authentication: '0.2.262.1.10.1.0.3',
  twoWayX509Authentication: '0.2.262.1.10.1.0.4',
  threeWayX509Authentication: '0.2.262.1.10.1.0.5',
  oneWayISO9798Authentication: '0.2.262.1.10.1.0.6',
  twoWayISO9798Authentication: '0.2.262.1.10.1.0.7',
  telekomAuthentication: '0.2.262.1.10.1.0.8',
  signature: '0.2.262.1.10.1.1',
  md4WithRSAAndISO9697: '0.2.262.1.10.1.1.1',
  md4WithRSAAndTelesecSignatureStandard: '0.2.262.1.10.1.1.2',
  md5WithRSAAndISO9697: '0.2.262.1.10.1.1.3',
  md5WithRSAAndTelesecSignatureStandard: '0.2.262.1.10.1.1.4',
  ripemd160WithRSAAndTelekomSignatureStandard: '0.2.262.1.10.1.1.5',
  hbciRsaSignature: '0.2.262.1.10.1.1.9',
  encryption: '0.2.262.1.10.1.2',
  none: '0.2.262.1.10.1.2.0',
  rsaTelesec: '0.2.262.1.10.1.2.1',
  des: '1.3.36.3.1.1',
  desECB: '1.3.14.3.2.6',
  desCBC: '1.3.14.3.2.7',
  desOFB: '1.3.14.3.2.8',
  desCFB8: '0.2.262.1.10.1.2.2.4',
  desCFB64: '0.2.262.1.10.1.2.2.5',
  des3: '0.2.262.1.10.1.2.3',
  des3ECB: '0.2.262.1.10.1.2.3.1',
  des3CBC: '0.2.262.1.10.1.2.3.2',
  des3OFB: '0.2.262.1.10.1.2.3.3',
  des3CFB8: '0.2.262.1.10.1.2.3.4',
  des3CFB64: '0.2.262.1.10.1.2.3.5',
  magenta: '0.2.262.1.10.1.2.4',
  idea: '1.3.36.3.1.2',
  ideaECB: '1.3.36.3.1.2.1',
  ideaCBC: '1.3.36.3.1.2.2',
  ideaOFB: '1.3.36.3.1.2.3',
  ideaCFB8: '0.2.262.1.10.1.2.5.4',
  ideaCFB64: '0.2.262.1.10.1.2.5.5',
  oneWayFunction: '0.2.262.1.10.1.3',
  md4: '1.2.840.113549.2.4',
  md5: '1.2.840.113549.2.5',
  sqModNX509: '0.2.262.1.10.1.3.3',
  sqModNISO: '0.2.262.1.10.1.3.4',
  ripemd128: '1.3.36.3.2.2',
  hashUsingBlockCipher: '0.2.262.1.10.1.3.6',
  mac: '0.2.262.1.10.1.3.7',
  ripemd160: '1.3.36.3.2.1',
  fecFunction: '0.2.262.1.10.1.4',
  reedSolomon: '0.2.262.1.10.1.4.1',
  module: '2.23.42.6',
  algorithms: '1.3.6.1.5.5.7.6',
  attributeTypes: '0.2.262.1.10.2.1',
  certificateTypes: '0.2.262.1.10.2.2',
  messageTypes: '0.2.262.1.10.2.3',
  plProtocol: '0.2.262.1.10.2.4',
  smeAndComponentsOfSme: '0.2.262.1.10.2.5',
  fec: '0.2.262.1.10.2.6',
  usefulDefinitions: '0.2.262.1.10.2.7',
  stefiles: '0.2.262.1.10.2.8',
  sadmib: '0.2.262.1.10.2.9',
  electronicOrder: '0.2.262.1.10.2.10',
  telesecTtpAsymmetricApplication: '0.2.262.1.10.2.11',
  telesecTtpBasisApplication: '0.2.262.1.10.2.12',
  telesecTtpMessages: '0.2.262.1.10.2.13',
  telesecTtpTimeStampApplication: '0.2.262.1.10.2.14',
  objectClass: '2.5.4.0',
  telesecOtherName: '0.2.262.1.10.3.0',
  directory: '2.16.840.1.113730.3',
  directoryType: '0.2.262.1.10.3.2',
  directoryGroup: '0.2.262.1.10.3.3',
  directoryUser: '0.2.262.1.10.3.4',
  symmetricKeyEntry: '0.2.262.1.10.3.5',
  package: '0.2.262.1.10.4',
  parameter: '0.2.262.1.10.5',
  nameBinding: '0.2.262.1.10.6',
  attribute: '2.23.42.3',
  applicationGroupIdentifier: '0.2.262.1.10.7.0',
  certificateType: '2.54.1775.3',
  telesecCertificate: '0.2.262.1.10.7.2',
  certificateNumber: '0.2.262.1.10.7.3',
  certificateRevocationList: '2.5.4.39',
  creationDate: '0.2.262.1.10.7.5',
  issuer: '0.2.262.1.10.7.6',
  namingAuthority: '0.2.262.1.10.7.7',
  publicKeyDirectory: '0.2.262.1.10.7.8',
  securityDomain: '0.2.262.1.10.7.9',
  subject: '0.2.262.1.10.7.10',
  timeOfRevocation: '0.2.262.1.10.7.11',
  userGroupReference: '0.2.262.1.10.7.12',
  validity: '0.2.262.1.10.7.13',
  zert93: '0.2.262.1.10.7.14',
  securityMessEnv: '0.2.262.1.10.7.15',
  anonymizedPublicKeyDirectory: '0.2.262.1.10.7.16',
  telesecGivenName: '0.2.262.1.10.7.17',
  nameAdditions: '0.2.262.1.10.7.18',
  telesecPostalCode: '0.2.262.1.10.7.19',
  nameDistinguisher: '0.2.262.1.10.7.20',
  telesecCertificateList: '0.2.262.1.10.7.21',
  teletrustCertificateList: '0.2.262.1.10.7.22',
  x509CertificateList: '0.2.262.1.10.7.23',
  timeOfIssue: '0.2.262.1.10.7.24',
  physicalCardNumber: '0.2.262.1.10.7.25',
  fileType: '0.2.262.1.10.7.26',
  ctlFileIsArchive: '0.2.262.1.10.7.27',
  emailAddress: '1.2.840.113549.1.9.1',
  certificateTemplateList: '0.2.262.1.10.7.29',
  directoryName: '0.2.262.1.10.7.30',
  directoryTypeName: '0.2.262.1.10.7.31',
  directoryGroupName: '0.2.262.1.10.7.32',
  directoryUserName: '0.2.262.1.10.7.33',
  revocationFlag: '0.2.262.1.10.7.34',
  symmetricKeyEntryName: '0.2.262.1.10.7.35',
  glNumber: '0.2.262.1.10.7.36',
  goNumber: '0.2.262.1.10.7.37',
  gKeyData: '0.2.262.1.10.7.38',
  zKeyData: '0.2.262.1.10.7.39',
  ktKeyData: '0.2.262.1.10.7.40',
  ktKeyNumber: '0.2.262.1.10.7.41',
  timeOfRevocationGen: '0.2.262.1.10.7.51',
  liabilityText: '0.2.262.1.10.7.52',
  attributeGroup: '0.2.262.1.10.8',
  action: '0.2.262.1.10.9',
  notification: '0.2.262.1.10.10',
  'snmp-mibs': '0.2.262.1.10.11',
  securityApplication: '0.2.262.1.10.11.1',
  certAndCrlExtensionDefinitions: '0.2.262.1.10.12',
  certExtensionLiabilityLimitationExt: '0.2.262.1.10.12.0',
  telesecCertIdExt: '0.2.262.1.10.12.1',
  'Telesec policyIdentifier': '0.2.262.1.10.12.2',
  telesecPolicyQualifierID: '0.2.262.1.10.12.3',
  telesecCRLFilteredExt: '0.2.262.1.10.12.4',
  telesecCRLFilterExt: '0.2.262.1.10.12.5',
  telesecNamingAuthorityExt: '0.2.262.1.10.12.6',
  userID: '0.9.2342.19200300.100.1.1',
  rfc822Mailbox: '0.9.2342.19200300.100.1.3',
  domainComponent: '0.9.2342.19200300.100.1.25',
  australianBusinessNumber: '1.2.36.1.333.1',
  'Certificates Australia policyIdentifier': '1.2.36.75878867.1.100.1.1',
  'Signet personal': '1.2.36.68980861.1.1.2',
  'Signet business': '1.2.36.68980861.1.1.3',
  'Signet legal': '1.2.36.68980861.1.1.4',
  'Signet pilot': '1.2.36.68980861.1.1.10',
  'Signet intraNet': '1.2.36.68980861.1.1.11',
  'Signet policyIdentifier': '1.2.36.68980861.1.1.20',
  'symmetric-encryption-algorithm': '1.2.392.200011.61.1.1.1',
  'misty1-cbc': '1.2.392.200011.61.1.1.1.1',
  'seis-cp': '1.2.752.34.1',
  'SEIS high-assurance policyIdentifier': '1.2.752.34.1.1',
  'SEIS GAK policyIdentifier': '1.2.752.34.1.2',
  'SEIS pe': '1.2.752.34.2',
  'SEIS at': '1.2.752.34.3',
  'SEIS at-personalIdentifier': '1.2.752.34.3.1',
  'x9f1-cert-mgmt': '1.2.840.10040.1.1',
  holdinstruction: '1.2.840.10040.2',
  'holdinstruction-none': '1.2.840.10040.2.1',
  callissuer: '1.2.840.10040.2.2',
  reject: '1.2.840.10040.2.3',
  pickupToken: '1.2.840.10040.2.4',
  countersignature: '1.2.840.113549.1.9.6',
  'attribute-cert': '1.2.840.10040.3.2',
  algorithm: '2.23.42.4',
  dsa: '1.3.14.3.2.12',
  'dsa-match': '1.2.840.10040.4.2',
  dsaWithSha1: '1.2.840.10040.4.3',
  fieldType: '1.2.840.10046.1',
  'prime-field': '1.2.840.10045.1.1',
  'characteristic-two-field': '1.2.840.10045.1.2',
  'characteristic-two-basis': '1.2.840.10045.1.2.3',
  onBasis: '1.2.840.10045.1.2.3.1',
  tpBasis: '1.2.840.10045.1.2.3.2',
  ppBasis: '1.2.840.10045.1.2.3.3',
  publicKeyType: '1.2.840.10045.2',
  ecPublicKey: '1.2.840.10045.2.1',
  'gf-prime': '1.2.840.10046.1.1',
  numberType: '1.2.840.10046.2',
  dhPublicKey: '1.2.840.10046.2.1',
  scheme: '1.2.840.10046.3',
  dhStatic: '1.2.840.10046.3.1',
  dhEphem: '1.2.840.10046.3.2',
  dhHybrid1: '1.2.840.10046.3.3',
  dhHybrid2: '1.2.840.10046.3.4',
  mqv2: '1.2.840.10046.3.5',
  mqv1: '1.2.840.10046.3.6',
  healthcareLicense: '1.2.840.10065.2.3',
  'license?': '1.2.840.10065.2.3.1.1',
  nsn: '1.2.840.113533.7',
  'nsn-ce': '1.2.840.113533.7.65',
  entrustVersInfo: '1.2.840.113533.7.65.0',
  'nsn-alg': '1.2.840.113533.7.66',
  cast3CBC: '1.2.840.113533.7.66.3',
  cast5CBC: '1.2.840.113533.7.66.10',
  cast5MAC: '1.2.840.113533.7.66.11',
  'pbeWithMD5AndCAST5-CBC': '1.2.840.113533.7.66.12',
  passwordBasedMac: '1.2.840.113533.7.66.13',
  'nsn-oc': '1.2.840.113533.7.67',
  entrustUser: '1.2.840.113533.7.67.0',
  'nsn-at': '1.2.840.113533.7.68',
  entrustCAInfo: '1.2.840.113533.7.68.0',
  attributeCertificate: '2.5.4.58',
  'pkcs-1': '1.2.840.113549.1.1',
  rsaEncryption: '1.3.36.3.1.4',
  md2withRSAEncryption: '1.2.840.113549.1.1.2',
  md4withRSAEncryption: '1.2.840.113549.1.1.3',
  md5withRSAEncryption: '1.2.840.113549.1.1.4',
  sha1withRSAEncryption: '1.2.840.113549.1.1.5',
  rsaOAEP: '1.2.840.113549.1.1.7',
  'rsaOAEP-MGF': '1.2.840.113549.1.1.8',
  'rsaOAEP-pSpecified': '1.2.840.113549.1.1.9',
  rsaPSS: '1.2.840.113549.1.1.10',
  sha256WithRSAEncryption: '1.2.840.113549.1.1.11',
  sha384WithRSAEncryption: '1.2.840.113549.1.1.12',
  sha512WithRSAEncryption: '1.2.840.113549.1.1.13',
  rsaOAEPEncryptionSET: '1.2.840.113549.1.1.6',
  bsafeRsaEncr: '1.2.840.113549.1.2',
  dhKeyAgreement: '1.2.840.113549.1.3.1',
  'pbeWithMD2AndDES-CBC': '1.2.840.113549.1.5.1',
  'pbeWithMD5AndDES-CBC': '1.2.840.113549.1.5.3',
  'pbeWithMD2AndRC2-CBC': '1.2.840.113549.1.5.4',
  'pbeWithMD5AndRC2-CBC': '1.2.840.113549.1.5.6',
  pbeWithMD5AndXOR: '1.2.840.113549.1.5.9',
  'pbeWithSHAAndDES-CBC': '1.2.840.113549.1.5.10',
  pkcs5PBKDF2: '1.2.840.113549.1.5.12',
  pkcs5PBES2: '1.2.840.113549.1.5.13',
  pkcs5PBMAC1: '1.2.840.113549.1.5.14',
  data: '1.2.840.113549.1.7.1',
  signedData: '1.2.840.113549.1.7.2',
  envelopedData: '1.2.840.113549.1.7.3',
  signedAndEnvelopedData: '1.2.840.113549.1.7.4',
  digestedData: '1.2.840.113549.1.7.5',
  encryptedData: '1.2.840.113549.1.7.6',
  dataWithAttributes: '1.2.840.113549.1.7.7',
  encryptedPrivateKeyInfo: '1.2.840.113549.1.9.25.2',
  'pkcs-9': '1.2.840.113549.1.9',
  unstructuredName: '1.2.840.113549.1.9.2',
  contentType: '2.23.42.0',
  messageDigest: '1.2.840.113549.1.9.4',
  signingTime: '1.2.840.113549.1.9.5',
  challengePassword: '1.2.840.113549.1.9.7',
  unstructuredAddress: '1.2.840.113549.1.9.8',
  extendedCertificateAttributes: '1.2.840.113549.1.9.9',
  issuerAndSerialNumber: '1.2.840.113549.1.9.10',
  passwordCheck: '1.2.840.113549.1.9.11',
  publicKey: '1.2.840.113549.1.9.12',
  signingDescription: '1.2.840.113549.1.9.13',
  extensionRequest: '1.2.840.113549.1.9.14',
  sMIMECapabilities: '1.2.840.113549.1.9.15',
  preferSignedData: '1.2.840.113549.1.9.15.1',
  canNotDecryptAny: '1.2.840.113549.1.9.15.2',
  receiptRequest: '1.2.840.113549.1.9.16.2.1',
  receipt: '1.2.840.113549.1.9.16.1.1',
  contentHints: '1.2.840.113549.1.9.15.5',
  mlExpansionHistory: '1.2.840.113549.1.9.15.6',
  'id-sMIME': '1.2.840.113549.1.9.16',
  'id-mod': '1.2.840.113549.1.9.16.0',
  'id-mod-cms': '1.2.840.113549.1.9.16.0.1',
  'id-mod-ess': '1.2.840.113549.1.9.16.0.2',
  'id-mod-oid': '1.2.840.113549.1.9.16.0.3',
  'id-mod-msg-v3': '1.2.840.113549.1.9.16.0.4',
  'id-mod-ets-eSignature-88': '1.2.840.113549.1.9.16.0.5',
  'id-mod-ets-eSignature-97': '1.2.840.113549.1.9.16.0.6',
  'id-mod-ets-eSigPolicy-88': '1.2.840.113549.1.9.16.0.8',
  authData: '1.2.840.113549.1.9.16.1.2',
  publishCert: '1.2.840.113549.1.9.16.1.3',
  tSTInfo: '1.2.840.113549.1.9.16.1.4',
  tDTInfo: '1.2.840.113549.1.9.16.1.5',
  contentInfo: '1.2.840.113549.1.9.16.1.6',
  dVCSRequestData: '1.2.840.113549.1.9.16.1.7',
  dVCSResponseData: '1.2.840.113549.1.9.16.1.8',
  compressedData: '1.2.840.113549.1.9.16.1.9',
  authenticatedAttributes: '1.2.840.113549.1.9.16.2',
  securityLabel: '1.2.840.113549.1.9.16.2.2',
  mlExpandHistory: '1.2.840.113549.1.9.16.2.3',
  contentHint: '1.2.840.113549.1.9.16.2.4',
  msgSigDigest: '1.2.840.113549.1.9.16.2.5',
  encapContentType: '1.2.840.113549.1.9.16.2.6',
  contentIdentifier: '1.2.840.113549.1.9.16.2.7',
  macValue: '1.2.840.113549.1.9.16.2.8',
  equivalentLabels: '1.2.840.113549.1.9.16.2.9',
  contentReference: '1.2.840.113549.1.9.16.2.10',
  encrypKeyPref: '1.2.840.113549.1.9.16.2.11',
  signingCertificate: '1.2.840.113549.1.9.16.2.12',
  smimeEncryptCerts: '1.2.840.113549.1.9.16.2.13',
  timeStampToken: '1.2.840.113549.1.9.16.2.14',
  'ets-sigPolicyId': '1.2.840.113549.1.9.16.2.15',
  'ets-commitmentType': '1.2.840.113549.1.9.16.2.16',
  'ets-signerLocation': '1.2.840.113549.1.9.16.2.17',
  'ets-signerAttr': '1.2.840.113549.1.9.16.2.18',
  'ets-otherSigCert': '1.2.840.113549.1.9.16.2.19',
  'ets-contentTimestamp': '1.2.840.113549.1.9.16.2.20',
  'ets-CertificateRefs': '1.2.840.113549.1.9.16.2.21',
  'ets-RevocationRefs': '1.2.840.113549.1.9.16.2.22',
  'ets-certValues': '1.2.840.113549.1.9.16.2.23',
  'ets-revocationValues': '1.2.840.113549.1.9.16.2.24',
  'ets-escTimeStamp': '1.2.840.113549.1.9.16.2.25',
  'ets-certCRLTimestamp': '1.2.840.113549.1.9.16.2.26',
  'ets-archiveTimeStamp': '1.2.840.113549.1.9.16.2.27',
  signatureType: '1.2.840.113549.1.9.16.2.28',
  'dvcs-dvc': '1.2.840.113549.1.9.16.2.29',
  algESDHwith3DES: '1.2.840.113549.1.9.16.3.1',
  algESDHwithRC2: '1.2.840.113549.1.9.16.3.2',
  alg3DESwrap: '1.2.840.113549.1.9.16.3.3',
  algRC2wrap: '1.2.840.113549.1.9.16.3.4',
  esDH: '1.2.840.113549.1.9.16.3.5',
  cms3DESwrap: '1.2.840.113549.1.9.16.3.6',
  cmsRC2wrap: '1.2.840.113549.1.9.16.3.7',
  zlib: '1.2.840.113549.1.9.16.3.8',
  'pwri-KEK': '1.2.840.113549.1.9.16.3.9',
  'certDist-ldap': '1.2.840.113549.1.9.16.4.1',
  'sigPolicyQualifier-ets-sqt-uri': '1.2.840.113549.1.9.16.5.1',
  'sigPolicyQualifier-ets-sqt-unotice': '1.2.840.113549.1.9.16.5.2',
  'id-cti-ets-proofOfOrigin': '1.2.840.113549.1.9.16.6.1',
  'id-cti-ets-proofOfReceipt': '1.2.840.113549.1.9.16.6.2',
  'id-cti-ets-proofOfDelivery': '1.2.840.113549.1.9.16.6.3',
  'id-cti-ets-proofOfSender': '1.2.840.113549.1.9.16.6.4',
  'id-cti-ets-proofOfApproval': '1.2.840.113549.1.9.16.6.5',
  'id-cti-ets-proofOfCreation': '1.2.840.113549.1.9.16.6.6',
  signatureTypeIdentifier: '1.2.840.113549.1.9.16.9',
  originatorSig: '1.2.840.113549.1.9.16.9.1',
  domainSig: '1.2.840.113549.1.9.16.9.2',
  additionalAttributesSig: '1.2.840.113549.1.9.16.9.3',
  reviewSig: '1.2.840.113549.1.9.16.9.4',
  capabilities: '1.2.840.113549.1.9.16.11',
  preferBinaryInside: '1.2.840.113549.1.9.16.11.1',
  friendlyName: 'for.PKCS.#12.1.2.840.113549.1.9.20',
  localKeyID: 'for.PKCS.#12.1.2.840.113549.1.9.21',
  certTypes: 'for.PKCS.#12.1.2.840.113549.1.9.22',
  x509Certificate: 'for.PKCS.#12.1.2.840.113549.1.9.22.1',
  sdsiCertificate: 'for.PKCS.#12.1.2.840.113549.1.9.22.2',
  crlTypes: 'for.PKCS.#12.1.2.840.113549.1.9.23',
  x509Crl: 'for.PKCS.#12.1.2.840.113549.1.9.23.1',
  pkcs9objectClass: '1.2.840.113549.1.9.24',
  pkcs9attributes: '1.2.840.113549.1.9.25',
  pkcs15Token: '1.2.840.113549.1.9.25.1',
  randomNonce: '1.2.840.113549.1.9.25.3',
  sequenceNumber: '1.2.840.113549.1.9.25.4',
  pkcs7PDU: '1.2.840.113549.1.9.25.5',
  pkcs9syntax: '1.2.840.113549.1.9.1A',
  pkcs9matchingRules: '1.2.840.113549.1.9.1B',
  'pkcs-12': '1.2.840.113549.1.12',
  'pkcs-12-PbeIds': '1.2.840.113549.1.12.1',
  pbeWithSHAAnd128BitRC4: '1.2.840.113549.1.12.1.1',
  pbeWithSHAAnd40BitRC4: '1.2.840.113549.1.12.1.2',
  'pbeWithSHAAnd3-KeyTripleDES-CBC': '1.2.840.113549.1.12.1.3',
  'pbeWithSHAAnd2-KeyTripleDES-CBC': '1.2.840.113549.1.12.1.4',
  'pbeWithSHAAnd128BitRC2-CBC': '1.2.840.113549.1.12.1.5',
  'pbeWithSHAAnd40BitRC2-CBC': '1.2.840.113549.1.12.1.6',
  'pkcs-12-ESPVKID': '1.2.840.113549.1.12.2',
  'pkcs-12-PKCS8KeyShrouding': '1.2.840.113549.1.12.2.1',
  'pkcs-12-BagIds': '1.2.840.113549.1.12.3',
  'pkcs-12-keyBagId': '1.2.840.113549.1.12.3.1',
  'pkcs-12-certAndCRLBagId': '1.2.840.113549.1.12.3.2',
  'pkcs-12-secretBagId': '1.2.840.113549.1.12.3.3',
  'pkcs-12-safeContentsId': '1.2.840.113549.1.12.3.4',
  'pkcs-12-pkcs-8ShroudedKeyBagId': '1.2.840.113549.1.12.3.5',
  'pkcs-12-CertBagID': '1.2.840.113549.1.12.4',
  'pkcs-12-X509CertCRLBagID': '1.2.840.113549.1.12.4.1',
  'pkcs-12-SDSICertBagID': '1.2.840.113549.1.12.4.2',
  'pkcs-12-PBEID': '1.2.840.113549.1.12.5.1',
  'pkcs-12-PBEWithSha1And128BitRC4': '1.2.840.113549.1.12.5.1.1',
  'pkcs-12-PBEWithSha1And40BitRC4': '1.2.840.113549.1.12.5.1.2',
  'pkcs-12-PBEWithSha1AndTripleDESCBC': '1.2.840.113549.1.12.5.1.3',
  'pkcs-12-PBEWithSha1And128BitRC2CBC': '1.2.840.113549.1.12.5.1.4',
  'pkcs-12-PBEWithSha1And40BitRC2CBC': '1.2.840.113549.1.12.5.1.5',
  'pkcs-12-PBEWithSha1AndRC4': '1.2.840.113549.1.12.5.1.6',
  'pkcs-12-PBEWithSha1AndRC2CBC': '1.2.840.113549.1.12.5.1.7',
  'pkcs-12-RSAEncryptionWith128BitRC4': '1.2.840.113549.1.12.5.2.1',
  'pkcs-12-RSAEncryptionWith40BitRC4': '1.2.840.113549.1.12.5.2.2',
  'pkcs-12-RSAEncryptionWithTripleDES': '1.2.840.113549.1.12.5.2.3',
  'pkcs-12-RSASignatureWithSHA1Digest': '1.2.840.113549.1.12.5.3.1',
  'pkcs-12-keyBag': '1.2.840.113549.1.12.10.1.1',
  'pkcs-12-pkcs-8ShroudedKeyBag': '1.2.840.113549.1.12.10.1.2',
  'pkcs-12-certBag': '1.2.840.113549.1.12.10.1.3',
  'pkcs-12-crlBag': '1.2.840.113549.1.12.10.1.4',
  'pkcs-12-secretBag': '1.2.840.113549.1.12.10.1.5',
  'pkcs-12-safeContentsBag': '1.2.840.113549.1.12.10.1.6',
  pkcs15modules: '1.2.840.113549.1.15.1',
  pkcs15attributes: '1.2.840.113549.1.15.2',
  pkcs15contentType: '1.2.840.113549.1.15.3',
  pkcs15content: '1.2.840.113549.1.15.3.1',
  md2: '1.2.840.113549.2.2',
  hmacWithSHA1: '1.2.840.113549.2.7',
  rc2CBC: '1.2.840.113549.3.2',
  rc2ECB: '1.2.840.113549.3.3',
  rc4: '1.2.840.113549.3.4',
  rc4WithMAC: '1.2.840.113549.3.5',
  'desx-CBC': '1.2.840.113549.3.6',
  'des-EDE3-CBC': '1.2.840.113549.3.7',
  rc5CBC: '1.2.840.113549.3.8',
  'rc5-CBCPad': '1.2.840.113549.3.9',
  desCDMF: '1.2.840.113549.3.10',
  'Identrus unknown policyIdentifier': '1.2.840.114021.1.6.1',
  identrusOCSP: '1.2.840.114021.4.1',
  'site-Addressing': '1.2.840.113556.1.3.00',
  classSchema: '1.2.840.113556.1.3.13',
  attributeSchema: '1.2.840.113556.1.3.14',
  'mailbox-Agent': '1.2.840.113556.1.3.174',
  mailbox: '1.2.840.113556.1.3.22',
  container: '1.2.840.113556.1.3.23',
  mailRecipient: '1.2.840.113556.1.3.46',
  deliveryMechanism: '1.2.840.113556.1.2.241',
  microsoftExcel: '1.2.840.113556.4.3',
  titledWithOID: '1.2.840.113556.4.4',
  microsoftPowerPoint: '1.2.840.113556.4.5',
  spcIndirectDataContext: '1.3.6.1.4.1.311.2.1.4',
  spcAgencyInfo: '1.3.6.1.4.1.311.2.1.10',
  spcStatementType: '1.3.6.1.4.1.311.2.1.11',
  spcSpOpusInfo: '1.3.6.1.4.1.311.2.1.12',
  certReqExtensions: '1.3.6.1.4.1.311.2.1.14',
  spcPEImageData: '1.3.6.1.4.1.311.2.1.15',
  spcRawFileData: '1.3.6.1.4.1.311.2.1.18',
  spcStructuredStorageData: '1.3.6.1.4.1.311.2.1.19',
  spcJavaClassData: 'type.1.1.3.6.1.4.1.311.2.1.20',
  individualCodeSigning: '1.3.6.1.4.1.311.2.1.21',
  commercialCodeSigning: '1.3.6.1.4.1.311.2.1.22',
  spcLink: 'type.3.1.3.6.1.4.1.311.2.1.28',
  spcMinimalCriteriaInfo: '1.3.6.1.4.1.311.2.1.26',
  spcFinancialCriteriaInfo: '1.3.6.1.4.1.311.2.1.27',
  timestampRequest: '1.3.6.1.4.1.311.3.2.1',
  certTrustList: '1.3.6.1.4.1.311.10.1',
  nextUpdateLocation: '1.3.6.1.4.1.311.10.2',
  certTrustListSigning: '1.3.6.1.4.1.311.10.3.1',
  timeStampSigning: '1.3.6.1.4.1.311.10.3.2',
  serverGatedCrypto: '2.16.840.1.113730.4.1',
  encryptedFileSystem: '1.3.6.1.4.1.311.10.3.4',
  yesnoTrustAttr: '1.3.6.1.4.1.311.10.4.1',
  enrolmentCSP: '1.3.6.1.4.1.311.13.2.2',
  osVersion: '1.3.6.1.4.1.311.13.2.3',
  microsoftRecipientInfo: '1.3.6.1.4.1.311.16.4',
  msCertTemplateName: '1.3.6.1.4.1.311.20.2',
  cAKeyCertIndexPair: '1.3.6.1.4.1.311.21.1',
  originalFilename: '1.3.6.1.4.1.311.88.2.1',
  ascom: '1.3.6.1.4.1.188.7.1.1',
  ideaCFB: '1.3.36.3.1.2.4',
  'UNINETT policyIdentifier': '1.3.6.1.4.1.2428.10.1.1',
  'ICE-TEL policyIdentifier': '1.3.6.1.4.1.2712.10',
  'ICE-TEL Italian policyIdentifier': '1.3.6.1.4.1.2786.1.1.1',
  blowfishECB: '1.3.6.1.4.1.3029.1.1.1',
  blowfishCBC: '1.3.6.1.4.1.3029.1.1.2',
  blowfishCFB: '1.3.6.1.4.1.3029.1.1.3',
  blowfishOFB: '1.3.6.1.4.1.3029.1.1.4',
  elgamal: '1.3.6.1.4.1.3029.1.2.1',
  'elgamalWithSHA-1': '1.3.6.1.4.1.3029.1.2.1.1',
  'elgamalWithRIPEMD-160': '1.3.6.1.4.1.3029.1.2.1.2',
  cryptlibPresenceCheck: '1.3.6.1.4.1.3029.3.1.1',
  ocspResponseRTCS: '1.3.6.1.4.1.3029.3.1.2',
  ocspResponseRTCSExtended: '1.3.6.1.4.1.3029.3.1.3',
  crlExtReason: '1.3.6.1.4.1.3029.3.1.4',
  keyFeatures: '1.3.6.1.4.1.3029.3.1.5',
  pkiBoot: '1.3.6.1.4.1.3029.3.1.6',
  cryptlibContent: '1.3.6.1.4.1.3029.4.1',
  cryptlibConfigData: '1.3.6.1.4.1.3029.4.1.1',
  cryptlibUserIndex: '1.3.6.1.4.1.3029.4.1.2',
  cryptlibUserInfo: '1.3.6.1.4.1.3029.4.1.3',
  'mpeg-1': '1.3.6.1.4.1.3029.42.11172.1',
  'xYZZY policyIdentifier': '1.3.6.1.4.1.3029.88.89.90.90.89',
  eciaAscX12Edi: '1.3.6.1.4.1.3576.7',
  plainEDImessage: '1.3.6.1.4.1.3576.7.1',
  signedEDImessage: '1.3.6.1.4.1.3576.7.2',
  integrityEDImessage: '1.3.6.1.4.1.3576.7.5',
  iaReceiptMessage: '1.3.6.1.4.1.3576.7.65',
  iaStatusMessage: '1.3.6.1.4.1.3576.7.97',
  eciaEdifact: '1.3.6.1.4.1.3576.8',
  eciaNonEdi: '1.3.6.1.4.1.3576.9',
  timeproof: '1.3.6.1.4.1.5472',
  tss: '1.3.6.1.4.1.5472.1',
  tss80: '1.3.6.1.4.1.5472.1.1',
  tss380: '1.3.6.1.4.1.5472.1.2',
  tss400: '1.3.6.1.4.1.5472.1.3',
  secondaryPractices: '1.3.6.1.4.1.5770.0.3',
  physicianIdentifiers: '1.3.6.1.4.1.5770.0.4',
  comodoPolicy: '1.3.6.1.4.1.6449.1.2.1.3.1',
  rolUnicoNacional: '1.3.6.1.4.1.8231.1',
  gnu: '1.3.6.1.4.1.11591',
  'gnu-radius': '1.3.6.1.4.1.11591.1',
  'gnu-radar': '1.3.6.1.4.1.11591.3',
  gnuDigestAlgorithm: '1.3.6.1.4.1.11591.12',
  tiger: '1.3.6.1.4.1.11591.12.2',
  gnuEncryptionAlgorithm: '1.3.6.1.4.1.11591.13',
  serpent: '1.3.6.1.4.1.11591.13.2',
  'serpent128-ECB': '1.3.6.1.4.1.11591.13.2.1',
  'serpent128-CBC': '1.3.6.1.4.1.11591.13.2.2',
  'serpent128-OFB': '1.3.6.1.4.1.11591.13.2.3',
  'serpent128-CFB': '1.3.6.1.4.1.11591.13.2.4',
  'serpent192-ECB': '1.3.6.1.4.1.11591.13.2.21',
  'serpent192-CBC': '1.3.6.1.4.1.11591.13.2.22',
  'serpent192-OFB': '1.3.6.1.4.1.11591.13.2.23',
  'serpent192-CFB': '1.3.6.1.4.1.11591.13.2.24',
  'serpent256-ECB': '1.3.6.1.4.1.11591.13.2.41',
  'serpent256-CBC': '1.3.6.1.4.1.11591.13.2.42',
  'serpent256-OFB': '1.3.6.1.4.1.11591.13.2.43',
  'serpent256-CFB': '1.3.6.1.4.1.11591.13.2.44',
  pkix: '1.3.6.1.5.5.7',
  attributeCert: '1.3.6.1.5.5.7.0.12',
  privateExtension: '1.3.6.1.5.5.7.1',
  authorityInfoAccess: '1.3.6.1.5.5.7.1.1',
  biometricInfo: '1.3.6.1.5.5.7.1.2',
  qcStatements: '1.3.6.1.5.5.7.1.3',
  acAuditIdentity: '1.3.6.1.5.5.7.1.4',
  acTargeting: '1.3.6.1.5.5.7.1.5',
  acAaControls: '1.3.6.1.5.5.7.1.6',
  'sbgp-ipAddrBlock': '1.3.6.1.5.5.7.1.7',
  'sbgp-autonomousSysNum': '1.3.6.1.5.5.7.1.8',
  'sbgp-routerIdentifier': '1.3.6.1.5.5.7.1.9',
  acProxying: '1.3.6.1.5.5.7.1.10',
  subjectInfoAccess: '1.3.6.1.5.5.7.1.11',
  policyQualifierIds: '1.3.6.1.5.5.7.2',
  cps: '1.3.6.1.5.5.7.2.1',
  unotice: '1.3.6.1.5.5.7.2.2',
  textNotice: '1.3.6.1.5.5.7.2.3',
  keyPurpose: '1.3.6.1.5.5.7.3',
  serverAuth: '1.3.6.1.5.5.7.3.1',
  clientAuth: '1.3.6.1.5.5.7.3.2',
  codeSigning: '1.3.6.1.5.5.7.3.3',
  emailProtection: '1.3.6.1.5.5.7.3.4',
  ipsecEndSystem: '1.3.6.1.5.5.7.3.5',
  ipsecTunnel: '1.3.6.1.5.5.7.3.6',
  ipsecUser: '1.3.6.1.5.5.7.3.7',
  timeStamping: '1.3.6.1.5.5.7.48.3',
  ocspSigning: '1.3.6.1.5.5.7.3.9',
  dvcs: '1.3.6.1.5.5.7.3.10',
  sbgpCertAAServerAuth: '1.3.6.1.5.5.7.3.11',
  eapOverPPP: '1.3.6.1.5.5.7.3.13',
  wlanSSID: '1.3.6.1.5.5.7.3.14',
  cmpInformationTypes: '1.3.6.1.5.5.7.4',
  caProtEncCert: '1.3.6.1.5.5.7.4.1',
  signKeyPairTypes: '1.3.6.1.5.5.7.4.2',
  encKeyPairTypes: '1.3.6.1.5.5.7.4.3',
  preferredSymmAlg: '1.3.6.1.5.5.7.4.4',
  caKeyUpdateInfo: '1.3.6.1.5.5.7.4.5',
  currentCRL: '1.3.6.1.5.5.7.4.6',
  unsupportedOIDs: '1.3.6.1.5.5.7.4.7',
  keyPairParamReq: '1.3.6.1.5.5.7.4.10',
  keyPairParamRep: '1.3.6.1.5.5.7.4.11',
  revPassphrase: '1.3.6.1.5.5.7.4.12',
  implicitConfirm: '1.3.6.1.5.5.7.4.13',
  confirmWaitTime: '1.3.6.1.5.5.7.4.14',
  origPKIMessage: '1.3.6.1.5.5.7.4.15',
  suppLangTags: '1.3.6.1.5.5.7.4.16',
  crmfRegistration: '1.3.6.1.5.5.7.5',
  regCtrl: '1.3.6.1.5.5.7.5.1',
  regToken: '1.3.6.1.5.5.7.5.1.1',
  authenticator: '1.3.6.1.5.5.7.5.1.2',
  pkiPublicationInfo: '1.3.6.1.5.5.7.5.1.3',
  pkiArchiveOptions: '1.3.6.1.5.5.7.5.1.4',
  oldCertID: '1.3.6.1.5.5.7.5.1.5',
  protocolEncrKey: '1.3.6.1.5.5.7.5.1.6',
  altCertTemplate: '1.3.6.1.5.5.7.5.1.7',
  wtlsTemplate: '1.3.6.1.5.5.7.5.1.8',
  utf8Pairs: '1.3.6.1.5.5.7.5.2.1',
  certReq: '1.3.6.1.5.5.7.5.2.2',
  des40: '1.3.6.1.5.5.7.6.1',
  noSignature: '1.3.6.1.5.5.7.6.2',
  'dh-sig-hmac-sha1': '1.3.6.1.5.5.7.6.3',
  'dh-pop': '1.3.6.1.5.5.7.6.4',
  cmcControls: '1.3.6.1.5.5.7.7',
  otherNames: '1.3.6.1.5.5.7.8',
  personalData: '1.3.36.8.4.1',
  userGroup: '1.3.6.1.5.5.7.8.2',
  dateOfBirth: '1.3.6.1.5.5.7.9.1',
  placeOfBirth: '1.3.6.1.5.5.7.9.2',
  gender: '1.3.6.1.5.5.7.9.3',
  countryOfCitizenship: '1.3.6.1.5.5.7.9.4',
  countryOfResidence: '1.3.6.1.5.5.7.9.5',
  authenticationInfo: '1.3.6.1.5.5.7.10.1',
  accessIdentity: '1.3.6.1.5.5.7.10.2',
  chargingIdentity: '1.3.6.1.5.5.7.10.3',
  group: '1.3.6.1.5.5.7.10.4',
  role: '2.5.4.72',
  encAttrs: '1.3.6.1.5.5.7.10.6',
  'pkixQCSyntax-v1': '1.3.6.1.5.5.7.11.1',
  ocsp: '1.3.6.1.5.5.7.48.1',
  ocspBasic: '1.3.6.1.5.5.7.48.1.1',
  ocspNonce: '1.3.6.1.5.5.7.48.1.2',
  ocspCRL: '1.3.6.1.5.5.7.48.1.3',
  ocspResponse: '1.3.6.1.5.5.7.48.1.4',
  ocspNoCheck: '1.3.6.1.5.5.7.48.1.5',
  ocspArchiveCutoff: '1.3.6.1.5.5.7.48.1.6',
  ocspServiceLocator: '1.3.6.1.5.5.7.48.1.7',
  caIssuers: '1.3.6.1.5.5.7.48.2',
  caRepository: '1.3.6.1.5.5.7.48.5',
  hmacMD5: '1.3.6.1.5.5.8.1.1',
  hmacSHA: '1.3.6.1.5.5.8.1.2',
  hmacTiger: '1.3.6.1.5.5.8.1.3',
  iKEIntermediate: '1.3.6.1.5.5.8.2.2',
  decEncryptionAlgorithm: '1.3.12.2.1011.7.1',
  decDEA: '1.3.12.2.1011.7.1.2',
  decHashAlgorithm: '1.3.12.2.1011.7.2',
  decMD2: '1.3.12.2.1011.7.2.1',
  decMD4: '1.3.12.2.1011.7.2.2',
  decSignatureAlgorithm: '1.3.12.2.1011.7.3',
  decMD2withRSA: '1.3.12.2.1011.7.3.1',
  decMD4withRSA: '1.3.12.2.1011.7.3.2',
  decDEAMAC: '1.3.12.2.1011.7.3.3',
  sha: '1.3.14.3.2.18',
  rsa: '2.5.8.1.1',
  md4WitRSA: '1.3.14.3.2.2',
  md5WithRSA: '1.3.14.3.2.3',
  md4WithRSAEncryption: '1.3.14.3.2.4',
  'sqmod-N': '1.3.14.3.2.2.1',
  'sqmod-NwithRSA': '1.3.14.3.2.3.1',
  desCFB: '1.3.14.3.2.9',
  desMAC: '1.3.14.3.2.10',
  rsaSignature: '1.3.36.3.3.1',
  dsaWithSHA: '1.3.14.3.2.13',
  mdc2WithRSASignature: '1.3.14.3.2.14',
  shaWithRSASignature: '1.3.14.3.2.15',
  dhWithCommonModulus: '1.3.14.3.2.16',
  desEDE: '1.3.14.3.2.17',
  'mdc-2': '1.3.14.3.2.19',
  dsaCommon: '1.3.14.3.2.20',
  dsaCommonWithSHA: '1.3.14.3.2.21',
  rsaKeyTransport: '1.3.14.3.2.22',
  'keyed-hash-seal': '1.3.14.3.2.23',
  md2WithRSASignature: '1.3.14.3.2.24',
  md5WithRSASignature: '1.3.14.3.2.25',
  sha1: '1.3.14.3.2.26',
  dsaWithSHA1: '1.3.14.3.2.27',
  dsaWithCommonSHA1: '1.3.14.3.2.28',
  'sha-1WithRSAEncryption': '1.3.14.3.2.29',
  'simple-strong-auth-mechanism': '1.3.14.3.3.1',
  ElGamal: '1.3.14.7.2.1.1',
  md2WithRSA: '1.3.14.7.2.3.1',
  md2WithElGamal: '1.3.14.7.2.3.2',
  document: '1.3.36.1',
  finalVersion: '1.3.36.1.1',
  draft: '1.3.36.1.2',
  sio: '1.3.36.2',
  sedu: '1.3.36.2.1',
  encryptionAlgorithm: '1.3.36.3.1',
  desECB_pad: '1.3.36.3.1.1.1',
  desECB_ISOpad: '1.3.36.3.1.1.1.1',
  desCBC_pad: '1.3.36.3.1.1.2.1',
  desCBC_ISOpad: '1.3.36.3.1.1.2.1.1',
  des_3: '1.3.36.3.1.3',
  des_3ECB_pad: '1.3.36.3.1.3.1.1',
  des_3ECB_ISOpad: '1.3.36.3.1.3.1.1.1',
  des_3CBC_pad: '1.3.36.3.1.3.2.1',
  des_3CBC_ISOpad: '1.3.36.3.1.3.2.1.1',
  ideaECB_pad: '1.3.36.3.1.2.1.1',
  ideaECB_ISOpad: '1.3.36.3.1.2.1.1.1',
  ideaCBC_pad: '1.3.36.3.1.2.2.1',
  ideaCBC_ISOpad: '1.3.36.3.1.2.2.1.1',
  rsaEncryptionWithlmod512expe17: '1.3.36.3.1.4.512.17',
  'bsi-1': '1.3.36.3.1.5',
  bsi_1ECB_pad: '1.3.36.3.1.5.1',
  bsi_1CBC_pad: '1.3.36.3.1.5.2',
  bsi_1CBC_PEMpad: '1.3.36.3.1.5.2.1',
  hashAlgorithm: '1.3.36.3.2',
  ripemd256: '1.3.36.3.2.3',
  mdc2singleLength: '1.3.36.3.2.4',
  mdc2doubleLength: '1.3.36.3.2.5',
  signatureAlgorithm: '1.3.36.3.3',
  rsaSignatureWithsha1: '1.3.36.3.3.1.1',
  rsaSignatureWithsha1_l512_l2: '1.3.36.3.3.1.1.512.2',
  rsaSignatureWithsha1_l640_l2: '1.3.36.3.3.1.1.640.2',
  rsaSignatureWithsha1_l768_l2: '1.3.36.3.3.1.1.768.2',
  rsaSignatureWithsha1_l896_l2: '1.3.36.3.3.1.1.892.2',
  rsaSignatureWithsha1_l1024_l2: '1.3.36.3.3.1.1.1024.2',
  rsaSignatureWithsha1_l512_l3: '1.3.36.3.3.1.1.512.3',
  rsaSignatureWithsha1_l640_l3: '1.3.36.3.3.1.1.640.3',
  rsaSignatureWithsha1_l768_l3: '1.3.36.3.3.1.1.768.3',
  rsaSignatureWithsha1_l896_l3: '1.3.36.3.3.1.1.896.3',
  rsaSignatureWithsha1_l1024_l3: '1.3.36.3.3.1.1.1024.3',
  rsaSignatureWithsha1_l512_l5: '1.3.36.3.3.1.1.512.5',
  rsaSignatureWithsha1_l640_l5: '1.3.36.3.3.1.1.640.5',
  rsaSignatureWithsha1_l768_l5: '1.3.36.3.3.1.1.768.5',
  rsaSignatureWithsha1_l896_l5: '1.3.36.3.3.1.1.896.5',
  rsaSignatureWithsha1_l1024_l5: '1.3.36.3.3.1.1.1024.5',
  rsaSignatureWithsha1_l512_l9: '1.3.36.3.3.1.1.512.9',
  rsaSignatureWithsha1_l640_l9: '1.3.36.3.3.1.1.640.9',
  rsaSignatureWithsha1_l768_l9: '1.3.36.3.3.1.1.768.9',
  rsaSignatureWithsha1_l896_l9: '1.3.36.3.3.1.1.896.9',
  rsaSignatureWithsha1_l1024_l9: '1.3.36.3.3.1.1.1024.9',
  rsaSignatureWithsha1_l512_l11: '1.3.36.3.3.1.1.512.11',
  rsaSignatureWithsha1_l640_l11: '1.3.36.3.3.1.1.640.11',
  rsaSignatureWithsha1_l768_l11: '1.3.36.3.3.1.1.768.11',
  rsaSignatureWithsha1_l896_l11: '1.3.36.3.3.1.1.896.11',
  rsaSignatureWithsha1_l1024_l11: '1.3.36.3.3.1.1.1024.11',
  rsaSignatureWithripemd160: '1.3.36.3.3.1.2',
  rsaSignatureWithripemd160_l512_l2: '1.3.36.3.3.1.2.512.2',
  rsaSignatureWithripemd160_l640_l2: '1.3.36.3.3.1.2.640.2',
  rsaSignatureWithripemd160_l768_l2: '1.3.36.3.3.1.2.768.2',
  rsaSignatureWithripemd160_l896_l2: '1.3.36.3.3.1.2.892.2',
  rsaSignatureWithripemd160_l1024_l2: '1.3.36.3.3.1.2.1024.2',
  rsaSignatureWithripemd160_l512_l3: '1.3.36.3.3.1.2.512.3',
  rsaSignatureWithripemd160_l640_l3: '1.3.36.3.3.1.2.640.3',
  rsaSignatureWithripemd160_l768_l3: '1.3.36.3.3.1.2.768.3',
  rsaSignatureWithripemd160_l896_l3: '1.3.36.3.3.1.2.896.3',
  rsaSignatureWithripemd160_l1024_l3: '1.3.36.3.3.1.2.1024.3',
  rsaSignatureWithripemd160_l512_l5: '1.3.36.3.3.1.2.512.5',
  rsaSignatureWithripemd160_l640_l5: '1.3.36.3.3.1.2.640.5',
  rsaSignatureWithripemd160_l768_l5: '1.3.36.3.3.1.2.768.5',
  rsaSignatureWithripemd160_l896_l5: '1.3.36.3.3.1.2.896.5',
  rsaSignatureWithripemd160_l1024_l5: '1.3.36.3.3.1.2.1024.5',
  rsaSignatureWithripemd160_l512_l9: '1.3.36.3.3.1.2.512.9',
  rsaSignatureWithripemd160_l640_l9: '1.3.36.3.3.1.2.640.9',
  rsaSignatureWithripemd160_l768_l9: '1.3.36.3.3.1.2.768.9',
  rsaSignatureWithripemd160_l896_l9: '1.3.36.3.3.1.2.896.9',
  rsaSignatureWithripemd160_l1024_l9: '1.3.36.3.3.1.2.1024.9',
  rsaSignatureWithripemd160_l512_l11: '1.3.36.3.3.1.2.512.11',
  rsaSignatureWithripemd160_l640_l11: '1.3.36.3.3.1.2.640.11',
  rsaSignatureWithripemd160_l768_l11: '1.3.36.3.3.1.2.768.11',
  rsaSignatureWithripemd160_l896_l11: '1.3.36.3.3.1.2.896.11',
  rsaSignatureWithripemd160_l1024_l11: '1.3.36.3.3.1.2.1024.11',
  rsaSignatureWithrimpemd128: '1.3.36.3.3.1.3',
  rsaSignatureWithrimpemd256: '1.3.36.3.3.1.4',
  ecsieSign: '1.3.36.3.3.2',
  ecsieSignWithsha1: '1.3.36.3.3.2.1',
  ecsieSignWithripemd160: '1.3.36.3.3.2.2',
  ecsieSignWithmd2: '1.3.36.3.3.2.3',
  ecsieSignWithmd5: '1.3.36.3.3.2.4',
  signatureScheme: '1.3.36.3.4',
  'sigS_ISO9796-1': '1.3.36.3.4.1',
  'sigS_ISO9796-2': '1.3.36.3.4.2',
  'sigS_ISO9796-2Withred': '1.3.36.3.4.2.1',
  'sigS_ISO9796-2Withrsa': '1.3.36.3.4.2.2',
  'sigS_ISO9796-2Withrnd': '1.3.36.3.4.2.3',
  policy: '2.23.42.5',
  api: '1.3.36.6',
  'manufacturer-specific_api': '1.3.36.6.1',
  'utimaco-api': '1.3.36.6.1.1',
  'functionality-specific_api': '1.3.36.6.2',
  keymgmnt: '1.3.36.7',
  keyagree: '1.3.36.7.1',
  bsiPKE: '1.3.36.7.1.1',
  keytrans: '1.3.36.7.2',
  'encISO9796-2Withrsa': '1.3.36.7.2.1',
  'Teletrust SigiSigConform policyIdentifier': '1.3.36.8.1.1',
  directoryService: '1.3.36.8.2.1',
  dateOfCertGen: '1.3.36.8.3.1',
  procuration: '1.3.36.8.3.2',
  admission: '1.3.36.8.3.3',
  monetaryLimit: '1.3.36.8.3.4',
  declarationOfMajority: '1.3.36.8.3.5',
  integratedCircuitCardSerialNumber: '1.3.36.8.3.6',
  pKReference: '1.3.36.8.3.7',
  restriction: '1.3.36.8.4.8',
  retrieveIfAllowed: '1.3.36.8.3.9',
  requestedCertificate: '1.3.36.8.3.10',
  namingAuthorities: '1.3.36.8.3.11',
  certInDirSince: '1.3.36.8.3.12',
  certHash: '1.3.36.8.3.13',
  rsaIndicateSHA1: '1.3.36.8.5.1.1.1',
  rsaIndicateRIPEMD160: '1.3.36.8.5.1.1.2',
  rsaWithSHA1: '1.3.36.8.5.1.1.3',
  rsaWithRIPEMD160: '1.3.36.8.5.1.1.4',
  dsaExtended: '1.3.36.8.5.1.2.1',
  dsaWithRIPEMD160: '1.3.36.8.5.1.2.2',
  cert: '2.23.42.3.0',
  certRef: '1.3.36.8.6.2',
  attrCert: '1.3.36.8.6.3',
  attrRef: '1.3.36.8.6.4',
  fileName: '1.3.36.8.6.5',
  storageTime: '1.3.36.8.6.6',
  fileSize: '1.3.36.8.6.7',
  location: '1.3.36.8.6.8',
  sigNumber: '1.3.36.8.6.9',
  autoGen: '1.3.36.8.6.10',
  ptAdobeILL: '1.3.36.8.7.1.1',
  ptAmiPro: '1.3.36.8.7.1.2',
  ptAutoCAD: '1.3.36.8.7.1.3',
  ptBinary: '1.3.36.8.7.1.4',
  ptBMP: '1.3.36.8.7.1.5',
  ptCGM: '1.3.36.8.7.1.6',
  ptCorelCRT: '1.3.36.8.7.1.7',
  ptCorelDRW: '1.3.36.8.7.1.8',
  ptCorelEXC: '1.3.36.8.7.1.9',
  ptCorelPHT: '1.3.36.8.7.1.10',
  ptDraw: '1.3.36.8.7.1.11',
  ptDVI: '1.3.36.8.7.1.12',
  ptEPS: '1.3.36.8.7.1.13',
  ptExcel: '1.3.36.8.7.1.14',
  ptGEM: '1.3.36.8.7.1.15',
  ptGIF: '1.3.36.8.7.1.16',
  ptHPGL: '1.3.36.8.7.1.17',
  ptJPEG: '1.3.36.8.7.1.18',
  ptKodak: '1.3.36.8.7.1.19',
  ptLaTeX: '1.3.36.8.7.1.20',
  ptLotus: '1.3.36.8.7.1.21',
  ptLotusPIC: '1.3.36.8.7.1.22',
  ptMacPICT: '1.3.36.8.7.1.23',
  ptMacWord: '1.3.36.8.7.1.24',
  ptMSWfD: '1.3.36.8.7.1.25',
  ptMSWord: '1.3.36.8.7.1.26',
  ptMSWord2: '1.3.36.8.7.1.27',
  ptMSWord6: '1.3.36.8.7.1.28',
  ptMSWord8: '1.3.36.8.7.1.29',
  ptPDF: '1.3.36.8.7.1.30',
  ptPIF: '1.3.36.8.7.1.31',
  ptPostscript: '1.3.36.8.7.1.32',
  ptRTF: '1.3.36.8.7.1.33',
  ptSCITEX: '1.3.36.8.7.1.34',
  ptTAR: '1.3.36.8.7.1.35',
  ptTarga: '1.3.36.8.7.1.36',
  ptTeX: '1.3.36.8.7.1.37',
  ptText: '1.3.36.8.7.1.38',
  ptTIFF: '1.3.36.8.7.1.39',
  'ptTIFF-FC': '1.3.36.8.7.1.40',
  ptUID: '1.3.36.8.7.1.41',
  ptUUEncode: '1.3.36.8.7.1.42',
  ptWMF: '1.3.36.8.7.1.43',
  ptWordPerfect: '1.3.36.8.7.1.44',
  ptWPGrph: '1.3.36.8.7.1.45',
  'thawte-ce': '1.3.101.1.4',
  strongExtranet: '1.3.101.1.4.1',
  aliasedEntryName: '2.5.4.1',
  knowledgeInformation: '2.5.4.2',
  commonName: '2.5.4.3',
  surname: '2.5.4.4',
  serialNumber: '2.5.4.5',
  countryName: '2.5.4.6',
  localityName: '2.5.4.7',
  collectiveLocalityName: '2.5.4.7.1',
  stateOrProvinceName: '2.5.4.8',
  collectiveStateOrProvinceName: '2.5.4.8.1',
  streetAddress: '2.5.4.9',
  collectiveStreetAddress: '2.5.4.9.1',
  organizationName: '2.5.4.10',
  collectiveOrganizationName: '2.5.4.10.1',
  organizationalUnitName: '2.5.4.11',
  collectiveOrganizationalUnitName: '2.5.4.11.1',
  title: '2.5.4.12',
  description: '2.5.4.13',
  searchGuide: '2.5.4.14',
  businessCategory: '2.5.4.15',
  postalAddress: '2.5.4.16',
  collectivePostalAddress: '2.5.4.16.1',
  postalCode: '2.5.4.17',
  collectivePostalCode: '2.5.4.17.1',
  postOfficeBox: '2.5.4.18',
  collectivePostOfficeBox: '2.5.4.18.1',
  physicalDeliveryOfficeName: '2.5.4.19',
  collectivePhysicalDeliveryOfficeName: '2.5.4.19.1',
  telephoneNumber: '2.5.4.20',
  collectiveTelephoneNumber: '2.5.4.20.1',
  telexNumber: '2.5.4.21',
  collectiveTelexNumber: '2.5.4.21.1',
  teletexTerminalIdentifier: '2.5.4.22',
  collectiveTeletexTerminalIdentifier: '2.5.4.22.1',
  facsimileTelephoneNumber: '2.5.4.23',
  collectiveFacsimileTelephoneNumber: '2.5.4.23.1',
  x121Address: '2.5.4.24',
  internationalISDNNumber: '2.5.4.25',
  collectiveInternationalISDNNumber: '2.5.4.25.1',
  registeredAddress: '2.5.4.26',
  destinationIndicator: '2.5.4.27',
  preferredDeliveryMehtod: '2.5.4.28',
  presentationAddress: '2.5.4.29',
  supportedApplicationContext: '2.5.4.30',
  member: '2.5.4.31',
  owner: '2.5.4.32',
  roleOccupant: '2.5.4.33',
  seeAlso: '2.5.4.34',
  userPassword: '2.5.4.35',
  userCertificate: '2.5.4.36',
  caCertificate: '2.5.4.37',
  authorityRevocationList: '2.5.4.38',
  crossCertificatePair: '2.5.4.40',
  name: '2.5.4.41',
  givenName: '2.5.4.42',
  initials: '2.5.4.43',
  generationQualifier: '2.5.4.44',
  uniqueIdentifier: '2.5.4.45',
  dnQualifier: '2.5.4.46',
  enhancedSearchGuide: '2.5.4.47',
  protocolInformation: '2.5.4.48',
  distinguishedName: '2.5.4.49',
  uniqueMember: '2.5.4.50',
  houseIdentifier: '2.5.4.51',
  supportedAlgorithms: '2.5.4.52',
  deltaRevocationList: '2.5.4.53',
  dmdName: '2.5.4.54',
  clearance: '2.5.4.55',
  defaultDirQop: '2.5.4.56',
  attributeIntegrityInfo: '2.5.4.57',
  attributeCertificateRevocationList: '2.5.4.59',
  confKeyInfo: '2.5.4.60',
  aACertificate: '2.5.4.61',
  attributeDescriptorCertificate: '2.5.4.62',
  attributeAuthorityRevocationList: '2.5.4.63',
  familyInformation: '2.5.4.64',
  pseudonym: '2.5.4.65',
  communicationsService: '2.5.4.66',
  communicationsNetwork: '2.5.4.67',
  certificationPracticeStmt: '2.5.4.68',
  certificatePolicy: '2.5.4.69',
  pkiPath: '2.5.4.70',
  privPolicy: '2.5.4.71',
  delegationPath: '2.5.4.73',
  top: '2.5.6.0',
  alias: '2.5.6.1',
  country: '2.5.6.2',
  locality: '2.5.6.3',
  organization: '2.5.6.4',
  organizationalUnit: '2.5.6.5',
  person: '2.5.6.6',
  organizationalPerson: '2.5.6.7',
  organizationalRole: '2.5.6.8',
  groupOfNames: '2.5.6.9',
  residentialPerson: '2.5.6.10',
  applicationProcess: '2.5.6.11',
  applicationEntity: '2.5.6.12',
  dSA: '2.5.6.13',
  device: '2.5.6.14',
  strongAuthenticationUser: '2.5.6.15',
  certificateAuthority: '2.5.6.16',
  groupOfUniqueNames: '2.5.6.17',
  pkiUser: '2.5.6.21',
  pkiCA: '2.5.6.22',
  'X.500-Algorithms': '2.5.8',
  'X.500-Alg-Encryption': '2.5.8.1',
  authorityKeyIdentifier: '2.5.29.35',
  keyAttributes: '2.5.29.2',
  certificatePolicies: '2.5.29.32',
  keyUsageRestriction: '2.5.29.4',
  policyMapping: '2.5.29.5',
  subtreesConstraint: '2.5.29.6',
  subjectAltName: '2.5.29.17',
  issuerAltName: '2.5.29.18',
  subjectDirectoryAttributes: '2.5.29.9',
  basicConstraints: '2.5.29.19',
  nameConstraints: '2.5.29.30',
  policyConstraints: '2.5.29.36',
  subjectKeyIdentifier: '2.5.29.14',
  keyUsage: '2.5.29.15',
  privateKeyUsagePeriod: '2.5.29.16',
  cRLNumber: '2.5.29.20',
  cRLReason: '2.5.29.21',
  expirationDate: '2.5.29.22',
  instructionCode: '2.5.29.23',
  invalidityDate: '2.5.29.24',
  cRLDistributionPoints: '2.5.29.31',
  issuingDistributionPoint: '2.5.29.28',
  deltaCRLIndicator: '2.5.29.27',
  certificateIssuer: '2.5.29.29',
  anyPolicy: '2.5.29.32.0',
  policyMappings: '2.5.29.33',
  extKeyUsage: '2.5.29.37',
  freshestCRL: '2.5.29.46',
  inhibitAnyPolicy: '2.5.29.54',
  sdnsSignatureAlgorithm: '2.16.840.1.101.2.1.1.1',
  fortezzaSignatureAlgorithm: '2.16.840.1.101.2.1.1.2',
  sdnsConfidentialityAlgorithm: '2.16.840.1.101.2.1.1.3',
  fortezzaConfidentialityAlgorithm: '2.16.840.1.101.2.1.1.4',
  sdnsIntegrityAlgorithm: '2.16.840.1.101.2.1.1.5',
  fortezzaIntegrityAlgorithm: '2.16.840.1.101.2.1.1.6',
  sdnsTokenProtectionAlgorithm: '2.16.840.1.101.2.1.1.7',
  fortezzaTokenProtectionAlgorithm: '2.16.840.1.101.2.1.1.8',
  sdnsKeyManagementAlgorithm: '2.16.840.1.101.2.1.1.9',
  fortezzaKeyManagementAlgorithm: '2.16.840.1.101.2.1.1.10',
  sdnsKMandSigAlgorithm: '2.16.840.1.101.2.1.1.11',
  fortezzaKMandSigAlgorithm: '2.16.840.1.101.2.1.1.12',
  suiteASignatureAlgorithm: '2.16.840.1.101.2.1.1.13',
  suiteAConfidentialityAlgorithm: '2.16.840.1.101.2.1.1.14',
  suiteAIntegrityAlgorithm: '2.16.840.1.101.2.1.1.15',
  suiteATokenProtectionAlgorithm: '2.16.840.1.101.2.1.1.16',
  suiteAKeyManagementAlgorithm: '2.16.840.1.101.2.1.1.17',
  suiteAKMandSigAlgorithm: '2.16.840.1.101.2.1.1.18',
  fortezzaUpdatedSigAlgorithm: '2.16.840.1.101.2.1.1.19',
  fortezzaKMandUpdSigAlgorithms: '2.16.840.1.101.2.1.1.20',
  fortezzaUpdatedIntegAlgorithm: '2.16.840.1.101.2.1.1.21',
  keyExchangeAlgorithm: '2.16.840.1.101.2.1.1.22',
  fortezzaWrap80Algorithm: '2.16.840.1.101.2.1.1.23',
  kEAKeyEncryptionAlgorithm: '2.16.840.1.101.2.1.1.24',
  rfc822MessageFormat: '2.16.840.1.101.2.1.2.1',
  emptyContent: '2.16.840.1.101.2.1.2.2',
  cspContentType: '2.16.840.1.101.2.1.2.3',
  mspRev3ContentType: '2.16.840.1.101.2.1.2.42',
  mspContentType: '2.16.840.1.101.2.1.2.48',
  mspRekeyAgentProtocol: '2.16.840.1.101.2.1.2.49',
  mspMMP: '2.16.840.1.101.2.1.2.50',
  'mspRev3-1ContentType': '2.16.840.1.101.2.1.2.66',
  forwardedMSPMessageBodyPart: '2.16.840.1.101.2.1.2.72',
  mspForwardedMessageParameters: '2.16.840.1.101.2.1.2.73',
  forwardedCSPMsgBodyPart: '2.16.840.1.101.2.1.2.74',
  cspForwardedMessageParameters: '2.16.840.1.101.2.1.2.75',
  mspMMP2: '2.16.840.1.101.2.1.2.76',
  sdnsSecurityPolicy: '2.16.840.1.101.2.1.3.1',
  sdnsPRBAC: '2.16.840.1.101.2.1.3.2',
  mosaicPRBAC: '2.16.840.1.101.2.1.3.3',
  siSecurityPolicy: '2.16.840.1.101.2.1.3.10',
  siNASP: '2.16.840.1.101.2.1.3.10.0',
  siELCO: '2.16.840.1.101.2.1.3.10.1',
  siTK: '2.16.840.1.101.2.1.3.10.2',
  siDSAP: '2.16.840.1.101.2.1.3.10.3',
  siSSSS: '2.16.840.1.101.2.1.3.10.4',
  siDNASP: '2.16.840.1.101.2.1.3.10.5',
  siBYEMAN: '2.16.840.1.101.2.1.3.10.6',
  'siREL-US': '2.16.840.1.101.2.1.3.10.7',
  'siREL-AUS': '2.16.840.1.101.2.1.3.10.8',
  'siREL-CAN': '2.16.840.1.101.2.1.3.10.9',
  siREL_UK: '2.16.840.1.101.2.1.3.10.10',
  'siREL-NZ': '2.16.840.1.101.2.1.3.10.11',
  siGeneric: '2.16.840.1.101.2.1.3.10.12',
  genser: '2.16.840.1.101.2.1.3.11',
  genserNations: '2.16.840.1.101.2.1.3.11.0',
  genserComsec: '2.16.840.1.101.2.1.3.11.1',
  genserAcquisition: '2.16.840.1.101.2.1.3.11.2',
  genserSecurityCategories: '2.16.840.1.101.2.1.3.11.3',
  genserTagSetName: '2.16.840.1.101.2.1.3.11.3.0',
  defaultSecurityPolicy: '2.16.840.1.101.2.1.3.12',
  capcoMarkings: '2.16.840.1.101.2.1.3.13',
  capcoSecurityCategories: '2.16.840.1.101.2.1.3.13.0',
  capcoTagSetName1: '2.16.840.1.101.2.1.3.13.0.1',
  capcoTagSetName2: '2.16.840.1.101.2.1.3.13.0.2',
  capcoTagSetName3: '2.16.840.1.101.2.1.3.13.0.3',
  capcoTagSetName4: '2.16.840.1.101.2.1.3.13.0.4',
  sdnsKeyManagementCertificate: '2.16.840.1.101.2.1.5.1',
  sdnsUserSignatureCertificate: '2.16.840.1.101.2.1.5.2',
  sdnsKMandSigCertificate: '2.16.840.1.101.2.1.5.3',
  fortezzaKeyManagementCertificate: '2.16.840.1.101.2.1.5.4',
  fortezzaKMandSigCertificate: '2.16.840.1.101.2.1.5.5',
  fortezzaUserSignatureCertificate: '2.16.840.1.101.2.1.5.6',
  fortezzaCASignatureCertificate: '2.16.840.1.101.2.1.5.7',
  sdnsCASignatureCertificate: '2.16.840.1.101.2.1.5.8',
  auxiliaryVector: '2.16.840.1.101.2.1.5.10',
  mlReceiptPolicy: '2.16.840.1.101.2.1.5.11',
  mlMembership: '2.16.840.1.101.2.1.5.12',
  mlAdministrators: '2.16.840.1.101.2.1.5.13',
  alid: '2.16.840.1.101.2.1.5.14',
  janUKMs: '2.16.840.1.101.2.1.5.20',
  febUKMs: '2.16.840.1.101.2.1.5.21',
  marUKMs: '2.16.840.1.101.2.1.5.22',
  aprUKMs: '2.16.840.1.101.2.1.5.23',
  mayUKMs: '2.16.840.1.101.2.1.5.24',
  junUKMs: '2.16.840.1.101.2.1.5.25',
  julUKMs: '2.16.840.1.101.2.1.5.26',
  augUKMs: '2.16.840.1.101.2.1.5.27',
  sepUKMs: '2.16.840.1.101.2.1.5.28',
  octUKMs: '2.16.840.1.101.2.1.5.29',
  novUKMs: '2.16.840.1.101.2.1.5.30',
  decUKMs: '2.16.840.1.101.2.1.5.31',
  metaSDNSckl: '2.16.840.1.101.2.1.5.40',
  sdnsCKL: '2.16.840.1.101.2.1.5.41',
  metaSDNSsignatureCKL: '2.16.840.1.101.2.1.5.42',
  sdnsSignatureCKL: '2.16.840.1.101.2.1.5.43',
  sdnsCertificateRevocationList: '2.16.840.1.101.2.1.5.44',
  fortezzaCertificateRevocationList: '2.16.840.1.101.2.1.5.45',
  fortezzaCKL: '2.16.840.1.101.2.1.5.46',
  alExemptedAddressProcessor: '2.16.840.1.101.2.1.5.47',
  guard: '2.16.840.1.101.2.1.5.48',
  algorithmsSupported: '2.16.840.1.101.2.1.5.49',
  suiteAKeyManagementCertificate: '2.16.840.1.101.2.1.5.50',
  suiteAKMandSigCertificate: '2.16.840.1.101.2.1.5.51',
  suiteAUserSignatureCertificate: '2.16.840.1.101.2.1.5.52',
  prbacInfo: '2.16.840.1.101.2.1.5.53',
  prbacCAConstraints: '2.16.840.1.101.2.1.5.54',
  sigOrKMPrivileges: '2.16.840.1.101.2.1.5.55',
  commPrivileges: '2.16.840.1.101.2.1.5.56',
  labeledAttribute: '2.16.840.1.101.2.1.5.57',
  policyInformationFile: '2.16.840.1.101.2.1.5.58',
  secPolicyInformationFile: '2.16.840.1.101.2.1.5.59',
  cAClearanceConstraint: '2.16.840.1.101.2.1.5.60',
  cspExtns: '2.16.840.1.101.2.1.7.1',
  cspCsExtn: '2.16.840.1.101.2.1.7.1.0',
  mISSISecurityCategories: '2.16.840.1.101.2.1.8.1',
  standardSecurityLabelPrivileges: '2.16.840.1.101.2.1.8.2',
  sigPrivileges: '2.16.840.1.101.2.1.10.1',
  kmPrivileges: '2.16.840.1.101.2.1.10.2',
  namedTagSetPrivilege: '2.16.840.1.101.2.1.10.3',
  ukDemo: '2.16.840.1.101.2.1.11.1',
  usDODClass2: '2.16.840.1.101.2.1.11.2',
  usMediumPilot: '2.16.840.1.101.2.1.11.3',
  usDODClass4: '2.16.840.1.101.2.1.11.4',
  usDODClass3: '2.16.840.1.101.2.1.11.5',
  usDODClass5: '2.16.840.1.101.2.1.11.6',
  testSecurityPolicy: '2.16.840.1.101.2.1.12.0',
  tsp1: '2.16.840.1.101.2.1.12.0.1',
  tsp1SecurityCategories: '2.16.840.1.101.2.1.12.0.1.0',
  tsp1TagSetZero: '2.16.840.1.101.2.1.12.0.1.0.0',
  tsp1TagSetOne: '2.16.840.1.101.2.1.12.0.1.0.1',
  tsp1TagSetTwo: '2.16.840.1.101.2.1.12.0.1.0.2',
  tsp2: '2.16.840.1.101.2.1.12.0.2',
  tsp2SecurityCategories: '2.16.840.1.101.2.1.12.0.2.0',
  tsp2TagSetZero: '2.16.840.1.101.2.1.12.0.2.0.0',
  tsp2TagSetOne: '2.16.840.1.101.2.1.12.0.2.0.1',
  tsp2TagSetTwo: '2.16.840.1.101.2.1.12.0.2.0.2',
  kafka: '2.16.840.1.101.2.1.12.0.3',
  kafkaSecurityCategories: '2.16.840.1.101.2.1.12.0.3.0',
  kafkaTagSetName1: '2.16.840.1.101.2.1.12.0.3.0.1',
  kafkaTagSetName2: '2.16.840.1.101.2.1.12.0.3.0.2',
  kafkaTagSetName3: '2.16.840.1.101.2.1.12.0.3.0.3',
  tcp1: '2.16.840.1.101.2.1.12.1.1',
  slabel: '2.16.840.1.101.3.1',
  pki: '2.16.840.1.113719.1.9',
  'GAK policyIdentifier': '2.16.840.1.101.3.2.1',
  'FBCA-Rudimentary policyIdentifier': '2.16.840.1.101.3.2.1.3.1',
  'FBCA-Basic policyIdentifier': '2.16.840.1.101.3.2.1.3.2',
  'FBCA-Medium policyIdentifier': '2.16.840.1.101.3.2.1.3.3',
  'FBCA-High policyIdentifier': '2.16.840.1.101.3.2.1.3.4',
  GAK: '2.16.840.1.101.3.2.2',
  kRAKey: '2.16.840.1.101.3.2.2.1',
  extensions: '2.16.840.1.101.3.2.3',
  kRTechnique: '2.16.840.1.101.3.2.3.1',
  kRecoveryCapable: '2.16.840.1.101.3.2.3.2',
  kR: '2.16.840.1.101.3.2.3.3',
  keyrecoveryschemes: '2.16.840.1.101.3.2.4',
  krapola: '2.16.840.1.101.3.2.5',
  arpa: '2.16.840.1.101.3.3',
  nistAlgorithm: '2.16.840.1.101.3.4',
  aes: '2.16.840.1.101.3.4.1',
  'aes128-ECB': '2.16.840.1.101.3.4.1.1',
  'aes128-CBC': '2.16.840.1.101.3.4.1.2',
  'aes128-OFB': '2.16.840.1.101.3.4.1.3',
  'aes128-CFB': '2.16.840.1.101.3.4.1.4',
  'aes192-ECB': '2.16.840.1.101.3.4.1.21',
  'aes192-CBC': '2.16.840.1.101.3.4.1.22',
  'aes192-OFB': '2.16.840.1.101.3.4.1.23',
  'aes192-CFB': '2.16.840.1.101.3.4.1.24',
  'aes256-ECB': '2.16.840.1.101.3.4.1.41',
  'aes256-CBC': '2.16.840.1.101.3.4.1.42',
  'aes256-OFB': '2.16.840.1.101.3.4.1.43',
  'aes256-CFB': '2.16.840.1.101.3.4.1.44',
  'sha2-256': '2.16.840.1.101.3.4.2.1',
  'sha2-384': '2.16.840.1.101.3.4.2.2',
  'sha2-512': '2.16.840.1.101.3.4.2.3',
  novellAlgorithm: '2.16.840.1.113719.1.2.8',
  desCbcIV8: '2.16.840.1.113719.1.2.8.22',
  desCbcPadIV8: '2.16.840.1.113719.1.2.8.23',
  desEDE2CbcIV8: '2.16.840.1.113719.1.2.8.24',
  desEDE2CbcPadIV8: '2.16.840.1.113719.1.2.8.25',
  desEDE3CbcIV8: '2.16.840.1.113719.1.2.8.26',
  desEDE3CbcPadIV8: '2.16.840.1.113719.1.2.8.27',
  rc5CbcPad: '2.16.840.1.113719.1.2.8.28',
  md2WithRSAEncryptionBSafe1: '2.16.840.1.113719.1.2.8.29',
  md5WithRSAEncryptionBSafe1: '2.16.840.1.113719.1.2.8.30',
  sha1WithRSAEncryptionBSafe1: '2.16.840.1.113719.1.2.8.31',
  LMDigest: '2.16.840.1.113719.1.2.8.32',
  MD2: '2.16.840.1.113719.1.2.8.40',
  MD5: '2.16.840.1.113719.1.2.8.50',
  'IKEhmacWithSHA1-RSA': '2.16.840.1.113719.1.2.8.51',
  'IKEhmacWithMD5-RSA': '2.16.840.1.113719.1.2.8.52',
  rc2CbcPad: '2.16.840.1.113719.1.2.8.69',
  'SHA-1': '2.16.840.1.113719.1.2.8.82',
  rc2BSafe1Cbc: '2.16.840.1.113719.1.2.8.92',
  MD4: '2.16.840.1.113719.1.2.8.95',
  MD4Packet: '2.16.840.1.113719.1.2.8.130',
  rsaEncryptionBsafe1: '2.16.840.1.113719.1.2.8.131',
  NWPassword: '2.16.840.1.113719.1.2.8.132',
  'novellObfuscate-1': '2.16.840.1.113719.1.2.8.133',
  pkiAttributeType: '2.16.840.1.113719.1.9.4',
  securityAttributes: '2.16.840.1.113719.1.9.4.1',
  relianceLimit: '2.16.840.1.113719.1.9.4.2',
  'cert-extension': '2.16.840.1.113730.1',
  'netscape-cert-type': '2.16.840.1.113730.1.1',
  'netscape-base-url': '2.16.840.1.113730.1.2',
  'netscape-revocation-url': '2.16.840.1.113730.1.3',
  'netscape-ca-revocation-url': '2.16.840.1.113730.1.4',
  'netscape-cert-renewal-url': '2.16.840.1.113730.1.7',
  'netscape-ca-policy-url': '2.16.840.1.113730.1.8',
  'HomePage-url': '2.16.840.1.113730.1.9',
  EntityLogo: '2.16.840.1.113730.1.10',
  UserPicture: '2.16.840.1.113730.1.11',
  'netscape-ssl-server-name': '2.16.840.1.113730.1.12',
  'netscape-comment': '2.16.840.1.113730.1.13',
  'data-type': '2.16.840.1.113730.2',
  dataGIF: '2.16.840.1.113730.2.1',
  dataJPEG: '2.16.840.1.113730.2.2',
  dataURL: '2.16.840.1.113730.2.3',
  dataHTML: '2.16.840.1.113730.2.4',
  certSequence: '2.16.840.1.113730.2.5',
  certURL: '2.16.840.1.113730.2.6',
  ldapDefinitions: '2.16.840.1.113730.3.1',
  carLicense: '2.16.840.1.113730.3.1.1',
  departmentNumber: '2.16.840.1.113730.3.1.2',
  employeeNumber: '2.16.840.1.113730.3.1.3',
  employeeType: '2.16.840.1.113730.3.1.4',
  inetOrgPerson: '2.16.840.1.113730.3.2.2',
  verisignCZAG: '2.16.840.1.113733.1.6.3',
  verisignInBox: '2.16.840.1.113733.1.6.6',
  'Unknown Verisign VPN extension': '2.16.840.1.113733.1.6.13',
  'Verisign serverID': '2.16.840.1.113733.1.6.15',
  'Verisign policyIdentifier': '2.16.840.1.113733.1.7.1.1',
  verisignCPSv1notice: '2.16.840.1.113733.1.7.1.1.1',
  verisignCPSv1nsi: '2.16.840.1.113733.1.7.1.1.2',
  'Verisign SGC CA?': '2.16.840.1.113733.1.8.1',
  PANData: '2.23.42.0.0',
  PANToken: '2.23.42.0.1',
  PANOnly: '2.23.42.0.2',
  msgExt: '2.23.42.1',
  field: '2.23.42.2',
  fullName: '2.23.42.2.0',
  familyName: '2.23.42.2.2',
  birthFamilyName: '2.23.42.2.3',
  placeName: '2.23.42.2.4',
  identificationNumber: '2.23.42.2.5',
  month: '2.23.42.2.6',
  date: '2.23.42.2.7',
  address: '2.23.42.2.8',
  telephone: '2.23.42.2.9',
  amount: '2.23.42.2.10',
  accountNumber: '2.23.42.2.7.11',
  passPhrase: '2.23.42.2.7.12',
  rootKeyThumb: '2.23.42.3.0.0',
  additionalPolicy: '2.23.42.3.0.1',
  root: '2.23.42.5.0',
  certExt: '2.23.42.7',
  hashedRootKey: '2.54.1775.2',
  merchantData: '2.54.1775.4',
  cardCertRequired: '2.54.1775.5',
  tunneling: '2.54.1775.6',
  setExtensions: '2.23.42.7.5',
  setQualifier: '2.54.1775.7',
  brand: '2.23.42.8',
  'IATA-ATA': '2.23.42.8.1',
  VISA: '2.23.42.8.4',
  MasterCard: '2.23.42.8.5',
  Diners: '2.23.42.8.30',
  AmericanExpress: '2.23.42.8.34',
  Novus: '2.23.42.8.6011',
  vendor: '2.23.42.9',
  GlobeSet: '2.23.42.9.0',
  IBM: '2.23.42.9.1',
  CyberCash: '2.23.42.9.2',
  Terisa: '2.23.42.9.3',
  RSADSI: '2.23.42.9.4',
  VeriFone: '2.23.42.9.5',
  TrinTech: '2.23.42.9.6',
  BankGate: '2.23.42.9.7',
  GTE: '2.23.42.9.8',
  CompuSource: '2.23.42.9.9',
  Griffin: '2.23.42.9.10',
  Certicom: '2.23.42.9.11',
  OSS: '2.23.42.9.12',
  TenthMountain: '2.23.42.9.13',
  Antares: '2.23.42.9.14',
  ECC: '2.23.42.9.15',
  Maithean: '2.23.42.9.16',
  Netscape: '2.23.42.9.17',
  Verisign: '2.23.42.9.18',
  BlueMoney: '2.23.42.9.19',
  Lacerte: '2.23.42.9.20',
  Fujitsu: '2.23.42.9.21',
  eLab: '2.23.42.9.22',
  Entrust: '2.23.42.9.23',
  VIAnet: '2.23.42.9.24',
  III: '2.23.42.9.25',
  OpenMarket: '2.23.42.9.26',
  Lexem: '2.23.42.9.27',
  Intertrader: '2.23.42.9.28',
  Persimmon: '2.23.42.9.29',
  NABLE: '2.23.42.9.30',
  'espace-net': '2.23.42.9.31',
  Hitachi: '2.23.42.9.32',
  Microsoft: '2.23.42.9.33',
  NEC: '2.23.42.9.34',
  Mitsubishi: '2.23.42.9.35',
  NCR: '2.23.42.9.36',
  'e-COMM': '2.23.42.9.37',
  Gemplus: '2.23.42.9.38',
  national: '2.23.42.10',
  Japan: '2.23.42.10.392',
  'set-data': '2.54.1775.99',
  'GOST R 34.11/34.10-2001': '1.2.643.2.2.3',
  'GOST R 34.11/34.10-94': '1.2.643.2.2.4',
  'GOST R 34.11-94': '1.2.643.2.2.9',
  'GOST R 34.10-2001': '1.2.643.2.2.19',
  'GOST R 34.10-94': '1.2.643.2.2.20',
  'GOST 28147-89': '1.2.643.2.2.21',
  'id-GostR3411-94-TestParamSet': '1.2.643.2.2.30.0',
  'id-GostR3411-94-CryptoProParamSet': '1.2.643.2.2.30.1',
  'id-Gost28147-89-TestParamSet': '1.2.643.2.2.31.0',
  'id-Gost28147-89-CryptoPro-A-ParamSet': '1.2.643.2.2.31.1',
  'id-Gost28147-89-CryptoPro-B-ParamSet': '1.2.643.2.2.31.2',
  'id-Gost28147-89-CryptoPro-C-ParamSet': '1.2.643.2.2.31.3',
  'id-GostR3410-94-TestParamSet': '1.2.643.2.2.32.0',
  'id-GostR3410-94-CryptoPro-A-ParamSet': '1.2.643.2.2.32.2',
  'id-GostR3410-94-CryptoPro-B-ParamSet': '1.2.643.2.2.32.3',
  'id-GostR3410-94-CryptoPro-C-ParamSet': '1.2.643.2.2.32.4',
  'id-GostR3410-94-CryptoPro-D-ParamSet': '1.2.643.2.2.32.5',
  'id-GostR3410-2001-TestParamSet': '1.2.643.2.2.35.0',
  'id-GostR3410-2001-CryptoPro-A-ParamSet': '1.2.643.2.2.35.1',
  'id-GostR3410-2001-CryptoPro-B-ParamSet': '1.2.643.2.2.35.2',
  'id-GostR3410-2001-CryptoPro-C-ParamSet': '1.2.643.2.2.35.3',
  'TLS traffic audit': '1.2.643.2.2.34.1',
  'GOST R 34.10-2001 DH': '1.2.643.2.2.98',
  'GOST R 34.10-94 DH': '1.2.643.2.2.99',
  OGRN: '1.2.643.100.1',
  OGRNIP: '1.2.643.100.5',
  SNILS: '1.2.643.100.3',
  INN: '1.2.643.3.131.1.1',
});
